<div id="wrap" [ngClass]="{'bgblue': !IsSpecial}">
  <div class="common-back-btn-sight" id="closeBtn"  (click)="close();" *ngIf="isOpenClass==0&& type!== 'huatek' && !isTencent">
    <span>×</span>
  </div>

  <div id="head_wrap" class="fontSize18" [ngStyle]="{'font-size': isHarmonyOS ? '18px' : ''}" >
    情景模拟
  </div>

   <!-- 提醒 -->
   <app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

   <!-- 静态模拟修改 begin-->
  <div *ngIf="practiceList">
    <div *ngFor="let practice of practiceList;let i = index;" class="listeImgItem p{{practiceMetaId}}" (click)="goToNextStep(i)">
			<div [class]="'listeImgItemHead-Img icon icon-bg'+(i+1)">
				<i [class]="'icon icon-user'+(i+1)+ ' p'+practiceMetaId"></i>
				<div *ngIf="practiceList[i].status == 2" class="practice-status">
          	已完成
        </div>
			</div>
			<div class="listeImgItemHead fontSize16">
				{{ practice.title }}
			</div>
			<div class="listeImgItemContent fontSize14 lineHeight21">
				{{ i===0 && practiceMetaId!= 305 && practiceMetaId!= 315 && practiceMetaId!= 325 && practiceMetaId!= 335?'由于报告迟交引发的一系列的故事。': i===1 ? '如何辅导一个带有负面情绪的老员工？': practice.description }}
				<div class="entryBtn">进入</div>
			</div>
		</div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&isShowQuestionnaire&&learningPathMetaId!==405 && learningPathMetaId!==415 && !isTencent">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&!isShowQuestionnaire&&learningPathMetaId!==405 && learningPathMetaId!==415 && !isTencent">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>
  </div>

</div>
<app-questionnaire [enter]="1" [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire && !type && !isTencent" (onExit)="closeQuestionnaire()"></app-questionnaire>



// WEBPACK FOOTER //
// ./src/app/case-practice-list/case-practice-list.component.html